import { SxProps } from "@mui/material";

export const sxMenuItem: SxProps = {
  fontFamily: "Montserrat-Regular",
  fontSize: "var(--font-size-small)",
  color: "var(--primary-blue)",
  marginBottom: "2px",
};